import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import { queryClient } from './lib/react-query';
import { AppRouter } from './router/AppRouter';
import { DirectionProvider } from './components/shared/DirectionProvider';
import { AuthProvider } from './contexts/AuthContext';

// Control visibility of React Query DevTools (development tool)
// Set to true to enable, false to disable
const ENABLE_REACT_QUERY_DEVTOOLS = false;

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <DirectionProvider>
            <AppRouter />
            <Toaster position="top-right" richColors />
          </DirectionProvider>
        </AuthProvider>
      </BrowserRouter>
      {ENABLE_REACT_QUERY_DEVTOOLS && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}

export default App;
